import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { CRM_TICKETS_FEATURE_GROUP } from './group';

export const CRM_TICKETS_FEATURES = {
  READ: {
    guid: 'c7d2e5b8-1a43-4c69-8b27-6e9f1d2a0200',
    name: 'crm_tickets:read',
    description: 'View the CRM tickets page',
    action: 'read',
    product: 'crm',
    parentGuid: CRM_TICKETS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { CRM_TICKETS_FEATURE_GROUP } from './group';

export const CRM_TICKETS_MODULE: FeatureModule = {
  product: 'crm',
  groups: [CRM_TICKETS_FEATURE_GROUP],
  features: featureList(CRM_TICKETS_FEATURES),
};
